import React from 'react';
import './style.scss';

function DividerSVG() {
  return (
    <svg width="10" height="25" viewBox="0 0 10 39" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 34L5 5" stroke="#EAEAEA" strokeWidth="9" strokeLinecap="square" />
    </svg>
  );
}

export default DividerSVG;
